/**
 * Ambiente de develop — serviço mock publicado em `getnet-eng-dev`.
 *
 * É este arquivo que vai para o bucket: o `cd-develop.yml` roda
 * `build:deploy-dev`, que constrói na configuration `development`, e é lá que
 * o `fileReplacements` do `angular.json` troca `environment.ts` por este.
 * Mesmo desenho do serasa, onde `environment.development.ts` também descreve o
 * ambiente publicado de develop e não a máquina do dev.
 *
 * Para rodar contra o mock **local**, use `yarn start`, que constrói na
 * configuration `local` e cai no `environment.local.ts`.
 *
 * O host precisa estar no `CORS_ORIGINS` do mock
 * (`helm/values/celeroapiclientmock/getnet-eng-dev.yaml`), senão o browser
 * bloqueia a leitura mesmo com o serviço respondendo 200.
 */
export const environment = {
  /**
   * Origem de onde o bundle publica os próprios assets. O `ElementModule` monta
   * `${cdnUrl}/styles.css` e injeta no `head` da página anfitriã — sem isto o portal
   * carrega o `main.js` e os componentes aparecem sem estilo nenhum, porque quem
   * consome o bundle não tem como saber que existe um CSS ao lado dele. Mesmo
   * mecanismo do serasa.
   */
  cdnUrl: 'https://finance-develop-getnet-webcomponents.celero.mobi',
  apiUrl: 'https://getnet-develop-celero-api-client-mock.celero.mobi',
  /**
   * Origem dos assets estáticos compartilhados da frota. `Banks.getLogoSrc` do core-ts
   * monta `${staticUrl}/banks/logos/images/<bank_id>@1x.png` — com o campo vazio o
   * caminho saía relativo à origem da página e o cabeçalho de saldos pedia
   * `/banks/logos/images/033@1x.png`, respondendo 404 em qualquer ambiente.
   *
   * É o host genérico da Celero, não o do serasa: é dele que o próprio `styles.css` do
   * design system já busca a fonte de ícones (`/fonts/icons/cds-icons.woff`). Confirmado
   * que serve os logos — 033, 260 e o fallback ZZZ respondem 200 image/png.
   */
  staticUrl: 'https://static.celero.mobi',
  colorPalette: 'light',
  authenticationConfig: {
    issuer: 'https://getnet-develop-celero-api-client-mock.celero.mobi',
    redirectUri: `${window.location.origin}/silent-refresh.html`,
    clientId: 'client',
    scope: 'openid profile email',
  },
  /**
   * Feature flags desligadas — demo sem Flagsmith. `environmentID` vazio faz
   * o `preloadFeatureFlags` (em `configs/session-providers.ts`) nem chamar
   * `FeatureFlagService.init()` — evita tanto travar o APP_INITIALIZER
   * quanto o polling de 5min do SDK batendo num endpoint inexistente.
   */
  featureFlag: {
    environmentID: '',
    api: '',
    identity: 'client',
  },
};
